import React, { useEffect, useState } from 'react'
import styled from 'styled-components'
import { useTranslation } from 'react-i18next'

import colors from 'utils/colors'
import { FixMeLater } from 'types'
import { icons } from 'utils/icons'
import { POST } from 'locales/locales'
import { InputData, newsFeedActions } from 'app/slices/news-feed.slice'

import PostHeader from '../../_components/post-header/PostHeader'
import CustomFile from 'components/file/CustomFile'
import CustomIcon from 'components/icon/CustomIcon'
import CommonInput from '../../_components/common-input/CommonInput'
import { TextBox } from '@progress/kendo-react-inputs'
import { useAppDispatch, useAppSelector } from 'app/hooks'
import { useLazyGetNewsfeedShareTeamListQuery } from 'app/services/group.service'
import CustomFormInput from 'components/input/custom-form-input/CustomFormInput'
// import CustomText from 'components/text/CustomText'
import {  uniq } from 'lodash'
import { Chip } from '@progress/kendo-react-buttons'

interface ICreateNewPostModalContentProps {
  inputData: InputData
  avatar: string
  fullname: string
  isValid: boolean

  isPostLoading: boolean
  header: string
  onChangeInputHeader: (e: FixMeLater) => void
  onClose: () => void
  onNewPost: () => void
  onCancelFile: (index: number) => void
  onSelectEmoji: (e: FixMeLater) => void
  onChangeInputData: (text: string) => void
  onChangeSelectedTeam: (text: any) => void
}

const CreateNewPostModalContent = ({
  inputData,
  avatar,
  fullname,
  isValid,
  isPostLoading,
  header,

  onChangeInputHeader,
  onClose,
  onNewPost,
  onCancelFile,
  onSelectEmoji,
  onChangeInputData,
  onChangeSelectedTeam,
}: ICreateNewPostModalContentProps) => {
  const { t } = useTranslation()
  const dispatch = useAppDispatch()

  const [mentionsDropdown, setMentionsDropdown] = useState(false)

  const maxChars = useAppSelector((state) => state.system.data.inputMaxChar)

  const [teamList, setTeamList] = useState<any>([])

  const [selectedTeams, setSelectedTeams] = useState<any>([])

  const [teamSelectedOption, setTeamSelectedOption] = useState<FixMeLater>({title: t(POST.SELECT_TEAM)})

  const [getNewsfeedShareTeamList] = useLazyGetNewsfeedShareTeamListQuery()

  // Presigned URL'li dosya listesi
  const filesWithPresigned = inputData?.files || [];

  useEffect(() => {
    fetchTeams()
  }, [])

  const fetchTeams = async () => {
    try {
      const data = await getNewsfeedShareTeamList({})
      if (data?.data?.data) {
        const list = data.data.data.map((team: FixMeLater) => ({
          ...team,
          title: team.title || team.name,
          value: team.value || team._id,
          id: team.id || team._id,
        }))
        setTeamList(list)
        return
      }
    } catch (error) {
      console.error(error)
    }
  }

  const handleChange = (team: any) => {
    if (team?.value) {
      const teams = uniq([...selectedTeams, team])
      setSelectedTeams(teams)
      dispatch(newsFeedActions.setNewsfeedTeam(teams))
      setTeamSelectedOption(team)
      onChangeSelectedTeam(teams)
      setTeamList(teamList.filter((t: any) => t.value !== team.value))
    }
  }

  const onKeyDown = (event: React.KeyboardEvent<HTMLElement>) => {
    if (mentionsDropdown) return;

    event.key === 'Enter' && !event.shiftKey && event.preventDefault()

    if (
      event.key === 'Enter' &&
      isValid &&
      !event.shiftKey &&
      !mentionsDropdown &&
      !isPostLoading
    ) {
      onNewPost()
      onClose()
    }
  }

  const removeTeam = (team: any) =>{
    const teams = selectedTeams.filter((selectedTeam: any)=>selectedTeam._id != team._id)
    setSelectedTeams(teams)
    onChangeSelectedTeam(teams)
    setTeamSelectedOption({title: t(POST.SELECT_TEAM)})
    dispatch(newsFeedActions.setNewsfeedTeam(teams))
    setTeamList([...teamList, team])
  }

  return (
    <Wrapper>
      <PostHeader avatar={avatar} fullname={fullname} />

      <CustomFormInput
        type={'text'}
        dropdownType="List"
        disabled={(teamList ?? []).length === 0}
        dropDownData={teamList}
        selectedOption={teamSelectedOption}
        placeholder={t(POST.SELECT_TEAM)}
        onChange={(team: any) => handleChange(team)}
      />
      {selectedTeams?.length !== 0 && (
        <MultipleSearchWrapper>
          {selectedTeams?.map((team: any, index: number) => {
            return (
              <ChipWrapper
                key={team.value + index}
                text={team.name}
                value={team.value}
                removable={true}
                size={'small'}
                themeColor={'info'}
                fillMode={'solid'}
                disabled={false}
                onRemove={() => removeTeam(team)}
              />
            )
          })}
        </MultipleSearchWrapper>
      )}

      <div style={{ marginTop: '10px' }}>
        <TextBox
          maxLength={maxChars}
          value={header}
          onChange={onChangeInputHeader}
          style={{ fontSize: 16, borderRadius: 25, padding: '6px 10px' }}
          placeholder={t(POST.ENTER_A_HEADER)}
          required={true}
        />
      </div>
      {maxChars && (
        <HeaderCharacterCounter>{`${header.length}/${maxChars}`}</HeaderCharacterCounter>
      )}
      <CommonInput
        id={'common_input'}
        textInfo
        maxLength={maxChars}
        data={inputData}
        placeHolder={t(POST.CREATE_POST)}
        onMentionDropDown={setMentionsDropdown}
        onKeyDown={onKeyDown}
        onSelectEmoji={onSelectEmoji}
        onChangeInputData={onChangeInputData}
      />
      {maxChars && <CharacterCounter>{`${inputData.text.length}/${maxChars}`}</CharacterCounter>}
      {filesWithPresigned.length > 0 && (
        <Layout onClick={(event) => event.stopPropagation()}>
          {filesWithPresigned.map((file: FixMeLater, index: number) => {
            let url = '';
            if (file.url) {
              url = file.url;
            } else if (file instanceof File || file instanceof Blob) {
              url = URL.createObjectURL(file);
            }
            const name = file.originalName || file.name
            const mimetype = file?.mimetype || file?.type || ''
            const size = file?.size
            return (
              <FileMessageWrapper key={file?._id || file?.lastModified}>
                <CloseIcon
                  id="cancel-file"
                  iconPreset="small"
                  source={icons.closeIconWhite}
                  isCancel={false}
                  onClick={() => onCancelFile(index)}
                />
                <CustomFile
                  index={index}
                  sentAt={file.sentAt}
                  source={url}
                  mimetype={mimetype}
                  preset={'postInput'}
                  size={size}
                  filename={name}
                  thumbnail={file?.thumbnail}
                />
              </FileMessageWrapper>
            )
          })}
        </Layout>
      )}
    </Wrapper>
  )
}

export default CreateNewPostModalContent

const Wrapper = styled.div``

const Layout = styled.div`
  margin-bottom: 16px;
  margin-top: 16px;
  display: flex;
  flex-wrap: wrap;
  gap: 20px;
`
const FileMessageWrapper = styled.div`
  position: relative;
  #cancel-file {
    display: flex;
  }
  #loading-file {
    display: none;
  }
  max-width: 120px;
  max-height: 90px;
`

const ChipWrapper = styled(Chip)`
  background-color: ${colors.vime20};
  .k-chip-label,
  .k-chip-text {
    padding: 1px 3px;
  }
`

const CloseIcon = styled(CustomIcon).attrs((props: { isCancel: boolean }) => props)`
  display: ${({ isCancel }) => (isCancel ? 'flex' : 'none')};
  position: absolute;
  top: -5px;
  right: -5px;
  flex-shrink: 0;
  background-color: ${colors.vime};
  border-radius: 50%;
  align-items: center;
  justify-content: center;
  z-index: 2;
`
const CharacterCounter = styled.div`
  color: ${colors.gray60};
  font-size: 12px;
  display: block;
  margin-left: 8px;
`

const HeaderCharacterCounter = styled.div`
  color: ${colors.gray60};
  font-size: 12px;
  position: sticky;
  margin-top: 11px;
  margin-left: 12px;
  display: block;
`

const MultipleSearchWrapper = styled.div`
  display: flex;
  flex-wrap: wrap;
  column-gap: 6px;
  row-gap: 3px;
  margin-left: 5px;
  margin-bottom: 20px;
`